<div class="toast-container" aria-live="polite" aria-atomic="false" aria-label="Portal notifications">
  @for (toast of toasts(); track toast.id) {
  <article class="toast" [class.toast--error]="toast.kind === 'error'" [class.toast--success]="toast.kind === 'success'" [attr.role]="toast.kind === 'error' ? 'alert' : 'status'">
    <i [class]="toast.kind === 'success' ? 'bi bi-check-circle-fill' : 'bi bi-exclamation-triangle'" aria-hidden="true"></i>
    <div><strong>{{ toast.title }}</strong><p>{{ toast.message }}</p></div>
    <button type="button" (click)="dismiss(toast.id)" aria-label="Dismiss notification"><i class="bi bi-x" aria-hidden="true"></i></button>
  </article>
  }
</div>
